<template>
<div :style="{height:list.length < 4 ? '90px' : '210px'}" >
     <div class="bg" v-if="list.length > 0">
    <!-- 秒杀券 -->
    <div
      class="scroll"
      scroll-x
      :style="{ height: list.length < 4 ? '90px' : '210px' }"
    >
      <div
        class="flex-center scroll-view-container"
        :style="{ height: list.length < 4 ? '90px' : '210px' }"
      >
        <div
          :style="{width:(list.length === 3 || list.length > 4) ? '158px' : list.length === 1 ?'100%':'165px',margin: '0 8px 8px 0'}"
          v-for="item in list"
          :key="item.seckillId"
          @click='link(item)'
        >
          <card
            :cardData="item"
            :listLength="list.length"
            :width="list.length === 3 || list.length > 4 ? '158px' : list.length === 1 ?'100%':'165px'"
          ></card>
        </div>
        <div
          style="width: 8px;"
          :style="{ height: list.length < 4 ? '90px' : '210px' }"
        ></div>
      </div>
    </div>
  </div>

</div>

</template>

<script>
 import Vue from 'vue'
import card from '../flash-card/card'
export default {
  props: {
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
    shareId:{
      type: String,
      default: "",
    },
     vcardUrl:{
      type: String,
      default: "",
    },
    vcardData:{
      type: Object,
      default: function () {
        return {};
      },
    }
  },
  components: {
    card,
  },
  data() {
    return {}
  },
   // 组件方法
  methods: {
    async link(item) {
      let params ={posterData:this.vcardData}
      let redirectUri='fissionEquitys/seckilllDetail'
      let url=`seckillId=${item.seckillId}&shareId=${this.shareId||item.shareId}&vcardUrl=${this.vcardUrl}&vcardData=${encodeURIComponent(
            JSON.stringify(params.posterData)
          )}`
      Vue.ss.set('pageUrl',url)
      console.log('redirectUri',redirectUri)
       Vue.ss.set('redirectUri',redirectUri)
      console.log(url)
      console.log('pageUrl',Vue.ss.get('pageUrl'))
      if(this.$store.getters.isWeiXin){
        await this.$store.dispatch("wxLogin/wxLogin");
      }else{
          this.$Dialog.alert({
            message: '请在微信客户端打开链接',
          }).then(() => {
            // on close
          });
      }
    },
  },
}
</script>

<style lang="less" scoped>
.bg {
  // background: linear-gradient(
  //   168.07deg,
  //   #e42a28 0%,
  //   rgba(245, 112, 70, 0.88) 50.66%,
  //   #e6332d 77.11%
  // );
  // padding:16px 0;
  // position:absolute;
  // left:0;
  width:100%;
  .scroll-view-container {
    width: 100%;
    height: 210px;
    // padding: 0 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
  }
  .top-bg {
    height: 118px;
    background: url('https://img.esenyun.com/images/20200523/0aff7a45ffb44ce285cfdcfde3dda3d1.png')
      no-repeat;
    background-size: 100%;
  }
  .swiper-card {
    height: 300px;
    flex-wrap: wrap;
  }
  .title {
    padding-top: 12px;
    padding-left: 16px;
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #fff;
  }
  .subtitle {
    font-size: 10px;
    line-height: 12px;
    color: #ffeae9;
    margin-top: 4px;
    text-align: center;
  }
  .sales-people {
    font-weight: 600;
    font-size: 17px;
    line-height: 24px;
    padding: 6px 25px;
    color: #fff5db;
    border: 1px solid #f6c766;
    border-radius: 50px;
    background: linear-gradient(
      90deg,
      #f88c4f 0%,
      #e25a3f 59.05%,
      #d93036 100%
    );
    .num-bg {
      width: 20px;
      height: 20px;
      font-size: 16px;
      margin-right: 4px;
      justify-content: center;
      background: #d64e1c;
      border-radius: 1px;
    }
  }
  .scroll {
    width: 100%;
    overflow-x: auto;
  }
}
</style>
